export abstract class EnvironmentProvider<T> {
  public abstract get environment(): T;
}
